import { faCaretDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "@mui/material/Button"
import ButtonGroup from "@mui/material/ButtonGroup"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import Grow from "@mui/material/Grow"
import MenuItem from "@mui/material/MenuItem"
import MenuList from "@mui/material/MenuList"
import Paper from "@mui/material/Paper"
import Popper from "@mui/material/Popper"
import * as React from "react"
import { IActionButton } from "ui/model"

interface IGroupButtonsProps {
  buttons: IActionButton[]
  id?: string
  allDisabled?: boolean
}

export const GroupButtons = React.memo(({ buttons, id, allDisabled }: IGroupButtonsProps) => {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  return (
    <>
      <ButtonGroup variant="contained" ref={anchorRef}>
        <Button
          id={id ? `${id}-main` : undefined}
          size="small"
          disabled={allDisabled}
          onClick={() => {
            const button = buttons[selectedIndex]
            button.onClick()
          }}
          sx={{ p: "1rem !important" }}>
          {buttons[selectedIndex].label}
        </Button>
        <Button
          id={id ? `${id}-select` : undefined}
          size="small"
          disabled={allDisabled}
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={() => setOpen(prevOpen => !prevOpen)}
          sx={{ p: "1rem !important" }}>
          <FontAwesomeIcon icon={faCaretDown} />
        </Button>
      </ButtonGroup>
      <Popper sx={{ zIndex: 1 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom"
            }}>
            <Paper>
              <ClickAwayListener
                onClickAway={(event: Event) => {
                  if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
                    return
                  }
                  setOpen(false)
                }}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {buttons.map((b, index) => (
                    <MenuItem
                      id={id ? `${id}-select-option-${index}` : undefined}
                      key={index}
                      disabled={allDisabled}
                      selected={index === selectedIndex}
                      onClick={() => {
                        setSelectedIndex(index)
                        setOpen(false)
                      }}>
                      {b.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
})
